import axios from 'axios'
import { BehaviorSubject } from 'rxjs';
/* =============================================================================
Remuner software (c)
Vibe Consulting.
Componente : api
Description : Se encarga de la conección del frontend con las controladores del backend
Date Autor Modification
================================================================================
30/09/2021 Santiago Coca Rojas Creación – Se implementa el api desde cero.
================================================================================ */
const currentUserSubject = new BehaviorSubject(JSON.parse(localStorage.getItem('currentUser')));

/*Url api Backend  en el servidor*/
const apib = axios.create({
    baseURL: process.env.REACT_APP_API_ENDPOINT
    //baseURL: 'http://localhost:9091/'
})

const apiUser = axios.create({
    baseURL: process.env.REACT_APP_API_USER_ENDPOINT
    // baseURL: 'http://localhost:9095/'
})

const apiGet = axios.create({
    baseURL: process.env.REACT_APP_API_GET_ENDPOINT
})

const apiEpayco = axios.create({
    baseURL: process.env.REACT_APP_API_EPAYCO_ENDPOINT,
    headers: {
        Authorization: "Basic " + btoa("REMUNER_LITE_PAYMENT:Remuner_Lite_pag0s.2022")
    }
})

/*Firms API*/
export const postFirm = (payload, headerGroup) => apib.post(`/Configuration/PostConf_signature`, payload, { headers: headerGroup });
export const getFirm = (entity, client, token, headerGroup) => apiGet.get(`/Configuration/GetConf_signature/${entity}/${client}/${token}`, { headers: headerGroup });
export const putFirm = (payload, headerGroup) => apib.put(`/Configuration/PutConf_signature`, payload, { headers: headerGroup });
export const deleteFirm = (entity, client, id, headerGroup) => apib.delete(`/Configuration/DelConf_signature/${entity}/${client}/${id}`, { headers: headerGroup });
export const getValueListFirm = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_signature/${entity}/${client}`, { headers: headerGroup })

/*User real API*/
export const PostChange_password = (payload, headerGroup) => apib.post(`/users/PostChange_password`, payload, { headers: headerGroup })
export const saveUser = (payload, headerGroup) => apiUser.post(`/Security/saveUser`, payload, { headers: headerGroup });
export const saveUserToken = (payload) => apiUser.post(`/Security/saveUserToken`, payload)
export const getTimeNow = () => apiUser.get(`/Security/getTimeNow`)
export const getUserType = (headerGroup) => apiGet.get(`/users/GetType_user_app`, { headers: headerGroup })
export const acceptTerms = (payload, headerGroup) => apib.post(`/users/PostLegal_terms_user`, payload, { headers: headerGroup })

/*Identity real API*/

export const postIdentity = (payload, headerGroup) => apib.post(`/contract/PostIdentity`, payload, { headers: headerGroup });
export const putIdentity = (payload, headerGroup) => apib.put(`/contract/PutIdentity`, payload, { headers: headerGroup });
export const getIdentity = (entity, client, number_id, headerGroup) => apiGet.get(`/contract/GetIdentity/${entity}/${client}/${number_id}`, { headers: headerGroup });
export const getValueListIdentity = (headerGroup) => apiGet.get(`/lov_tables/GetList_create_person`, { headers: headerGroup });

/*Contract Real API*/

export const postContract = (payload, headerGroup) => apib.post(`/contract/PostContract`, payload, { headers: headerGroup });
export const putContract = (payload, headerGroup) => apib.put(`/contract/PutContract`, payload, { headers: headerGroup });
export const getContract = (entity, client, contract_id, headerGroup) => apiGet.get(`/contract/GetContract/${entity}/${client}/${contract_id}`, { headers: headerGroup });
export const getValueListContract = (headerGroup) => apiGet.get(`/lov_tables/GetList_create_employee`, { headers: headerGroup });
export const putContractSalary = (payload, headerGroup) => apib.put(`/contract/PutContract_salary`, payload, { headers: headerGroup });

/*Company real API */

export const postBusiness = (payload, headerGroup) => apib.post(`/business/PostBusiness`, payload, { headers: headerGroup });
export const putBusiness = (payload, headerGroup) => apib.put(`/business/PutBusiness`, payload, { headers: headerGroup });
export const getBusiness = (token, headerGroup) => apiGet.get(`/business/GetBusiness/${token}`, { headers: headerGroup });
//export const getValueListCompany1 = (headerGroup) => apiGet.get(`/lov_tables/GetList_registration_process`, {headers: headerGroup});
export const getValueListCompany = (headerGroup) => apiGet.get(`/lov_tables/GetList_config_data_company`, { headers: headerGroup });

/*Holidays Real API*/

export const getValueListHolidays = (headerGroup) => apiGet.get(`/lov_tables/GetList_config_holidays`, { headers: headerGroup });
/*CIR Real API*/

export const postReportCIR = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_cir`, payload, { headers: headerGroup })

/*Calendar Real API*/
export const getValueListCalendar = (calendar_type, headerGroup) => apiGet.get(`/process/GetCalendar/${calendar_type}`, { headers: headerGroup });
export const getLastCalendar = (entity, client, headerGroup) => apiGet.get(`/process/GetLast_Calendar_payroll/${entity}/${client}`, { headers: headerGroup });
export const getNoveltiesCalendar = (contract, headerGroup) => apiGet.get(`/process/GetCalendar_novelties/NM/${contract}`, { headers: headerGroup })
export const getNoveltiesCalendarSB = (contract, headerGroup) => apiGet.get(`/process/GetCalendar_novelties/NM-LD/${contract}`, { headers: headerGroup })

/*PayrollPayment Real API*/

export const executeProcess = (payload, headerGroup) => apib.post(`/process/PostExecute_Process`, payload, { headers: headerGroup })
export const getExecutedProcess = (entity, calendar, client, action, headerGroup) => apiGet.get(`/process/GetProcess_executed/${entity}/${calendar}/${client}/${action}`, { headers: headerGroup })
export const getBankFlat = (entity, client, date_pay, id_calendar, headerGroup) => apiGet.get(`/files_raw/GetBank_flat_file/${entity}/${client}/${date_pay}/${id_calendar}`, { headers: headerGroup })
export const postReportPayroll = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_nom`, payload, { headers: headerGroup })
export const postReportSalaryHistory = (payload, headerGroup) => apib.post(`/files_raw/PostReports_His_salary`, payload, { headers: headerGroup })
export const postReportHeadCount = (payload, headerGroup) => apib.post(`/files_raw/PostReports_head_count`, payload, { headers: headerGroup })

/*SocialSecurity API*/
export const postReportSocialSecurity = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_sso`, payload, { headers: headerGroup })

/*Archivo plano Real API*/
export const getValueFiles_raw = (entity, client, id_calendar, headerGroup) => apiGet.get(`/files_raw/GetPila_flat_file/${entity}/${client}/${id_calendar}`, { headers: headerGroup });

/*Reporte detallado Contabilidad API*/
export const postReportAccounting = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_ctb`, payload, { headers: headerGroup });

/*Reporte detallado Cesantias API*/
export const postReportSeverance = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_cess`, payload, { headers: headerGroup });
export const postReportFlatSeverance = (payload, headerGroup) => apib.post(`/files_raw/PostReports_flat_file_cess`, payload, { headers: headerGroup });

/*Login API*/
export const postLogin = (username, password, headerGroup) => apib.post(`/login?username=${username}&password=${password}`);

/*Login API*/
export const getContracts_client = (entity, client, token, headerGroup) => apiGet.get(`/contract/GetContracts_client/${entity}/${client}/${token}`, { headers: headerGroup });
/*Overtime API*/

export const getOvertimeLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_He_and_Rn/${entity}/${client}`, { headers: headerGroup })
export const postOvertime = (payload, headerGroup) => apib.post(`/novelties/PostHe_and_Rn`, payload, { headers: headerGroup })
export const getOvertime = (entity, client, occasional_id, headerGroup) => apiGet.get(`/novelties/GetHe_and_Rn/${entity}/${client}/${occasional_id}`, { headers: headerGroup })
export const putOvertime = (payload, headerGroup) => apib.put(`/novelties/PutHe_and_Rn/`, payload, { headers: headerGroup })
export const deleteOvertime = (entity, client, occasional_id, headerGroup) => apib.delete(`/novelties/DelHe_and_Rn/${entity}/${client}/${occasional_id}`, { headers: headerGroup })

/*Vacation API*/

export const getVacationLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Mod_Vac/${entity}/${client}`, { headers: headerGroup })
export const postVacation = (payload, headerGroup) => apib.post(`/novelties/PostNov_vacation`, payload, { headers: headerGroup })
export const getVacation = (entity, client, vacation_id, headerGroup) => apiGet.get(`/novelties/GetNov_vacation/${entity}/${client}/${vacation_id}`, { headers: headerGroup })
export const putVacation = (payload, headerGroup) => apib.put(`/novelties/PutNov_vacation/`, payload, { headers: headerGroup })
export const deleteVacation = (entity, client, vacation_id, headerGroup) => apib.delete(`/novelties/DelNov_vacation/${entity}/${client}/${vacation_id}`, { headers: headerGroup })
export const getEnd_DateVacation = (entity, client, date_ini, days, contrac_id, headerGroup) => apiGet.get(`/novelties/GetEnd_date_vacation/${entity}/${client}/${date_ini}/${days}/${contrac_id}`, { headers: headerGroup })
export const getValidDateIni = (entity, client, date_ini, contrac_id, headerGroup) => apiGet.get(`/novelties/GetValidated_business_day/${entity}/${client}/${date_ini}/${contrac_id}`, { headers: headerGroup })
export const postReportVacationHistory = (payload, headerGroup) => apib.post(`/files_raw/PostReports_His_vacation`, payload, { headers: headerGroup })

/*Reported API*/

export const getReportedLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Coc_Oca/${entity}/${client}`, { headers: headerGroup })
export const postReported = (payload, headerGroup) => apib.post(`/novelties/PostNov_reported`, payload, { headers: headerGroup })
export const getReported = (entity, client, occasional_id, headerGroup) => apiGet.get(`/novelties/GetNov_reported/${entity}/${client}/${occasional_id}`, { headers: headerGroup })
export const putReported = (payload, headerGroup) => apib.put(`/novelties/PutNov_reported`, payload, { headers: headerGroup })
export const deleteReported = (entity, client, occasional_id, headerGroup) => apib.delete(`/novelties/DelNov_reported/${entity}/${client}/${occasional_id}`, { headers: headerGroup })
export const getValueListReportedConcepts = (headerGroup) => apiGet.get(`/lov_tables/GetList_mod_concepts`, { headers: headerGroup })
export const postReportedConcept = (payload, headerGroup) => apib.post(`/Configuration/PostConcept`, payload, { headers: headerGroup })
export const getReportedConcept = (entity, client, concept, headerGroup) => apiGet.get(`/Configuration/GetConcept/${entity}/${client}/${concept}`, { headers: headerGroup })
export const putReportedConcept = (payload, headerGroup) => apib.put(`/Configuration/PutConcept`, payload, { headers: headerGroup })
export const deleteReportedConcept = (entity, client, concept, module, headerGroup) => apib.delete(`/Configuration/DelConcept/${entity}/${client}/${concept}/${module}`, { headers: headerGroup })
export const postReportedReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_His_reported`, payload, { headers: headerGroup })


/*Licenses API*/

export const getLicensesLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Mod_Abs/${entity}/${client}`, { headers: headerGroup })
export const postLicenses = (payload, headerGroup) => apib.post(`/novelties/PostNov_absence`, payload, { headers: headerGroup })
export const getLicenses = (entity, client, absence_id, headerGroup) => apiGet.get(`/novelties/GetNov_absence/${entity}/${client}/${absence_id}`, { headers: headerGroup })
export const putLicenses = (payload, headerGroup) => apib.put(`/novelties/PutNov_absence`, payload, { headers: headerGroup })
export const deleteLicenses = (entity, client, absence_id, headerGroup) => apib.delete(`/novelties/DelNov_absence/${entity}/${client}/${absence_id}`, { headers: headerGroup })
export const getLicenseEndDate = (entity, client, startDate, time, contract_id, headerGroup) => apiGet.get(`/novelties/GetEnd_date_absence/${entity}/${client}/${startDate}/${time}/${contract_id}`, { headers: headerGroup })
export const getLicenseExtension = (entity, client, contract_id, contingency, headerGroup) => apiGet.get(`/novelties/GetNovAbs_extension/${entity}/${client}/${contract_id}/${contingency}`, { headers: headerGroup })
export const postReportLicenseHistory = (payload, headerGroup) => apib.post(`/files_raw/PostReports_His_absence`, payload, { headers: headerGroup })

/*Statics API*/

export const getStaticsLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Coc_Sta/${entity}/${client}`, { headers: headerGroup })
// export const getConcepLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Coc_Sta/${entity}/${client}`, {headers: headerGroup})
export const postStatics = (payload, headerGroup) => apib.post(`/novelties/PostNov_Statics`, payload, { headers: headerGroup })
export const getStatics = (entity, client, static_id, headerGroup) => apiGet.get(`/novelties/GetNov_Statics/${entity}/${client}/${static_id}`, { headers: headerGroup })
export const putStatics = (payload, headerGroup) => apib.put(`/novelties/PutNov_Statics/`, payload, { headers: headerGroup })
export const deleteStatics = (entity, client, absence_id, headerGroup) => apib.delete(`/novelties/DelNov_Statics/${entity}/${client}/${absence_id}`, { headers: headerGroup })


/*Social_benefits API*/

export const getSocial_benefitsLists = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_Mod_termination/${entity}/${client}`, { headers: headerGroup })
export const postSocial_benefits = (payload, headerGroup) => apib.post(`/novelties/PostNov_termination`, payload, { headers: headerGroup })
export const getSocial_benefits = (entity, client, Social_benefits_id, headerGroup) => apiGet.get(`/novelties/GetNov_termination/${entity}/${client}/${Social_benefits_id}`, { headers: headerGroup })
export const putSocial_benefits = (payload, headerGroup) => apib.put(`/novelties/PutNov_termination`, payload, { headers: headerGroup })
export const deleteSocial_benefits = (entity, client, Social_benefits_id, headerGroup) => apib.delete(`/novelties/DelNov_termination/${entity}/${client}/${Social_benefits_id}`, { headers: headerGroup })

/*Social_benefits API*/

export const getUsersList = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_users/${entity}/${client}`, { headers: headerGroup })
export const postUsers = (payload, headerGroup) => apib.post(`/users/PostUser_client`, payload, { headers: headerGroup })
export const getUsers = (entity, client, userid, headerGroup) => apiGet.get(`/users/GetUser_client/${entity}/${client}/${userid}`, { headers: headerGroup })
export const putUsers = (payload, headerGroup) => apib.put(`/users/PutUser_client`, payload, { headers: headerGroup })
export const deleteUsers = (entity, client, Social_benefits_id, headerGroup) => apib.delete(`/users/DelUser_client/${entity}/${client}/${Social_benefits_id}`, { headers: headerGroup })

/*Jobs API*/

export const postJobs = (payload, headerGroup) => apib.post(`/business/PostJob`, payload, { headers: headerGroup })
export const getJobs = (entity, client, userid, headerGroup) => apiGet.get(`/business/GetJob/${entity}/${client}/${userid}`, { headers: headerGroup })
export const putJobs = (payload, headerGroup) => apib.put(`/business/PutJob`, payload, { headers: headerGroup })
export const deleteJobs = (entity, client, Social_benefits_id, headerGroup) => apib.delete(`/business/DelJob/${entity}/${client}/${Social_benefits_id}`, { headers: headerGroup })


/*Cost Center API*/

export const getCenCosList = (headerGroup) => apiGet.get(`/lov_tables/GetList_mod_cencos/`, { headers: headerGroup })
export const postCenCos = (payload, headerGroup) => apib.post(`/Configuration/PostConf_cencos`, payload, { headers: headerGroup })
export const getCenCos = (entity, client, userid, headerGroup) => apiGet.get(`/Configuration/GetConf_cencos/${entity}/${client}/${userid}`, { headers: headerGroup })
export const putCenCos = (payload, headerGroup) => apib.put(`/Configuration/PutConf_cencos`, payload, { headers: headerGroup })
export const deleteCenCos = (entity, client, cencosId, headerGroup) => apib.delete(`/Configuration/DelConf_cencos/${entity}/${client}/${cencosId}`, { headers: headerGroup })


/*Plan de cuentas conrtables API*/

export const getValNit = (entity, client, nit, headerGroup) => apiGet.get(`/Configuration/GetVal_nit_account/${entity}/${client}/${nit}`, { headers: headerGroup })
export const getAccountList = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_account/${entity}/${client}`, { headers: headerGroup })
export const postAccount = (payload, headerGroup) => apib.post(`/Configuration/PostParameters_account`, payload, { headers: headerGroup })
export const getAccount = (entity, client, accountId, headerGroup) => apiGet.get(`/Configuration/GetParameters_account/${entity}/${client}/${accountId}`, { headers: headerGroup })
export const putAccount = (payload, headerGroup) => apib.put(`/Configuration/PutParameters_account`, payload, { headers: headerGroup })
export const deleteAccount = (entity, client, accountId, headerGroup) => apib.delete(`/Configuration/DelParameters_account/${entity}/${client}/${accountId}`, { headers: headerGroup })
export const getAccountListDocumentType = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_files_raw_ctb/${entity}/${client}`, { headers: headerGroup })
export const postReportAccount = (payload, headerGroup) => apib.post(`/files_raw/PostReports_by_Name`, payload, { headers: headerGroup })

/*Payroll Configuration API*/

export const getPayrollConf = (entity, client, headerGroup) => apiGet.get(`/Configuration/GetConf_payroll/${entity}/${client}`, { headers: headerGroup })
export const putPayrollConf = (payload, headerGroup) => apib.put(`/Configuration/PutConf_payroll`, payload, { headers: headerGroup })
export const getPayrollGroupConf = (entity, client, idGroup, headerGroup) => apiGet.get(`/Configuration/GetConf_payroll_group/${entity}/${client}/${idGroup}`, { headers: headerGroup })
export const postPayrollGroupConf = (payload, headerGroup) => apib.post(`/Configuration/PostConf_payroll_group`, payload, { headers: headerGroup })
export const deletePayrollGroupConf = (entity, client, idGroup, concept, headerGroup) => apib.delete(`/Configuration/DelConf_payroll_group/${entity}/${client}/${idGroup}/${concept}`, { headers: headerGroup })
export const getValueListPayrollConf = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_config_payroll/${entity}/${client}`, { headers: headerGroup })
export const getConceptsPayrollConf = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_config_payroll_concepts/${entity}/${client}`, { headers: headerGroup })

/*Third API*/

export const getThirdList = (headerGroup) => apiGet.get(`/lov_tables/GetList_mod_third`, { headers: headerGroup })
export const postThird = (payload, headerGroup) => apib.post(`/Configuration/PostThird_account`, payload, { headers: headerGroup })
export const getThird = (entity, client, userid, headerGroup) => apiGet.get(`/Configuration/GetThird_account/${entity}/${client}/${userid}`, { headers: headerGroup })
export const putThird = (payload, headerGroup) => apib.put(`/Configuration/PutThird_account`, payload, { headers: headerGroup })
export const deleteThird = (entity, client, cencosId, headerGroup) => apib.delete(`/Configuration/DelThird_account/${entity}/${client}/${cencosId}`, { headers: headerGroup })

/**Get Token */
export const getToken = (headerGroup) => apiGet.get(`/Security/getToken`, { headers: headerGroup })


/*CIR configuration API */

export const getCIRConfList = (entity, client, option, headerGroup) => apiGet.get(`/lov_tables/GetList_config_cir/${entity}/${client}/${option}`, { headers: headerGroup })
export const postCIRConf = (payload, headerGroup) => apib.post(`/Configuration/PostConfig_Cir`, payload, { headers: headerGroup })
export const getCIRConf = (entity, client, idGroup, headerGroup) => apiGet.get(`/Configuration/GetConfig_Cir/${entity}/${client}/${idGroup}`, { headers: headerGroup })
export const deleteCIRConf = (entity, client, idGroup, concept, headerGroup) => apib.delete(`/Configuration/DelConfig_Cir/${entity}/${client}/${idGroup}/${concept}`, { headers: headerGroup })
export const confReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_config_cyr`, payload, { headers: headerGroup })

/*OpenPayroll API*/

export const getValueListOpenPayroll = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_query_acc/${entity}/${client}`, { headers: headerGroup })
export const postOpenPayroll = (payload, headerGroup) => apib.post(`/queries/PostPayroll_open`, payload, { headers: headerGroup })

/*HistoricPayroll API*/

export const getValueListHistoricPayroll = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_query_acc/${entity}/${client}`, { headers: headerGroup })
export const postHistoricPayroll = (payload, headerGroup) => apib.post(`/queries/PostPayroll_accumulated`, payload, { headers: headerGroup })
export const uploadHistoricPayroll = (payload, headerGroup) => apib.post(`/upload/PostUpload_accum_hist`, payload, { headers: headerGroup })

/*HistoricSocialSecurity API*/

export const getValueListHistoricSocialSecurity = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_query_sso/${entity}/${client}`, { headers: headerGroup })
export const postHistoricSocialSecurity = (payload, headerGroup) => apib.post(`/queries/PostSocial_security`, payload, { headers: headerGroup })

/*HistoricAccounting API*/

export const getValueListHistoricAccounting = (entity, client, headerGroup) => apiGet.get(`/lov_tables/GetList_mod_query_ctb/${entity}/${client}`, { headers: headerGroup })
export const postHistoricAccounting = (payload, headerGroup) => apib.post(`/queries/PostAux_Account`, payload, { headers: headerGroup })


/*Password*/

export const postSendEmail = (payload) => apiUser.post(`/Security/getToken`, payload)
export const postUpdatePassword = (payload) => apiUser.post(`/Security/updatePassword`, payload)
/*ElectronicPayroll API*/

export const postReportElectronicPayroll = (payload, headerGroup) => apib.post(`/files_raw/PostReports_mod_ne`, payload, { headers: headerGroup })
export const getTransferDataElectronicPayroll = (entity, client, calendar, headerGroup) => apiGet.get(`/process/GetTransfer_data_ne/${entity}/${client}/${calendar}`, { headers: headerGroup })
export const postTransferElectronicPayroll = (payload, headerGroup) => apib.post(`/process/PostSend_Xml`, payload, { headers: headerGroup })
export const putCune = (payload, headerGroup) => apib.put(`/process/PutCune_Xml`, payload, { headers: headerGroup })
export const electronicPayrollConf = (payload, headerGroup) => apib.post(`/files_raw/PostReports_config_ne`, payload, { headers: headerGroup })
export const getPDFFile = (entity, client, register, headerGroup) => apib.get(`/process/GetDocument_pdf_ne/${entity}/${client}/${register}`, { headers: headerGroup })

/*Support API*/

export const postSupportMail = (payload, headerGroup) => apib.post(`/support/PostSend_mail_support`, payload, { headers: headerGroup })


/*Modal pago nómina anterior API*/
export const getPayment = (entity, client, headerGroup) => apiGet.get(`/process/GetLastPayroll_payment/${entity}/${client}`, { headers: headerGroup })


/*Generate PDF API*/

export const postPDF = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_ex`, payload, { headers: headerGroup })

/*DIAN Process API*/
export const getListDIANProcess = (headerGroup) => apiGet.get(`/lov_tables/Getlist_enabling_process`, { headers: headerGroup })
export const postDIANProcess = (payload, headerGroup) => apib.post(`/Configuration/PostEnable_config_ne`, payload, { headers: headerGroup })
export const putDIANProcess = (payload, headerGroup) => apib.put(`/Configuration/PutEnable_config_ne`, payload, { headers: headerGroup })
export const getDIANProcess = (entity, client, headerGroup) => apiGet.get(`/Configuration/GetEnable_config_ne/${entity}/${client}`, { headers: headerGroup })
export const validateDIANProcess = (entity, client, headerGroup) => apiGet.get(`/Configuration/GetValidate_Enable_config_ne/${entity}/${client}`, { headers: headerGroup })

/*Generate PDF Voucher API*/
export const postPDFVoucher = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_voucher`, payload, { headers: headerGroup })
export const getVouchers = (payload, headerGroup) => apib.post(`/files_raw/PostRecords_pdf_voucher`, payload, { headers: headerGroup })

/*Verification code API*/

export const postVerificationCode = (payload, headerGroup) => apib.post(`/users/PostCode_user`, payload, { headers: headerGroup })
export const getVerificationCode = (headerGroup) => apiGet.get(`/users/GetCode_user`, { headers: headerGroup })

/*Endpoints Integracion ePayco */
export const getEpaycoParams = (headerGroup) => apiEpayco.get(`/remuner-lite/epayco/api/params/get`, { headers: headerGroup })
export const getEpaycoTransactions = (client, headerGroup) => apiEpayco.get(`/remuner-lite/epayco/api/transaction/get?params=${client}`, { headers: headerGroup })
export const postEpaycoTransaction = (user, params, headerGroup) => apiEpayco.post(`/remuner-lite/epayco/api/transaction/save?user=${user}&params=${params}`, { headers: headerGroup })
export const getCustomerInformation = (client, headerGroup) => apiEpayco.get(`/remuner-lite/epayco/customer/api/get?client=${client}`, { headers: headerGroup })

/*Lista de endpoints*/
export const postLegalTerms = (payload) => apiUser.post(`/Security/postLegalTerms`, payload);

/*Lista de endpoints para datos en pantalla de inicio*/
export const getGetPayroll_budget = (entity, client, headerGroup) => apiGet.get(`/process/GetPayroll_budget/${entity}/${client}`, { headers: headerGroup })
export const getGetEmployee_budget = (entity, client, headerGroup) => apiGet.get(`/process/GetEmployee_budget/${entity}/${client}`, { headers: headerGroup })
export const GetPending_invoices = (entity, client, headerGroup) => apiGet.get(`/process/GetPending_invoices/${entity}/${client}`, { headers: headerGroup })
export const getPassiveLabor = (entity, client, headerGroup) => apiGet.get(`/process/GetPassive_labor/${entity}/${client}`, { headers: headerGroup })
export const getTotalPassiveLabor = (entity, client, headerGroup) => apiGet.get(`/process/GetTotal_Passive_labor/${entity}/${client}`, { headers: headerGroup })
export const getPayAbsenceType = (entity, client, headerGroup) => apiGet.get(`/process/GetPay_Absence_type/${entity}/${client}`, { headers: headerGroup })
export const getPayAbsenceDays = (entity, client, headerGroup) => apiGet.get(`/process/GetPay_Absence_days/${entity}/${client}`, { headers: headerGroup })

/*Endpoints certificados de ingresos y retenciones */

export const getCIRVouchers = (payload, headerGroup) => apib.post(`/files_raw/PostRecords_pdf_cyr`, payload, { headers: headerGroup })
export const postPDFCIRVoucher = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_cyr`, payload, { headers: headerGroup })

/*Endpoints medios magnéticos*/

export const getFormat1009 = (payload, headerGroup) => apib.post(`/files_raw/PostReports_format_1009`, payload, { headers: headerGroup })
export const getFormat2276 = (payload, headerGroup) => apib.post(`/files_raw/PostReports_format_2276`, payload, { headers: headerGroup })


/*Endpoints cconsulta NE*/

export const getReadDataElectronicPayroll = (entity, client, year, month, headerGroup) => apiGet.get(`/process/GetTransfer_data_ne_ym/${entity}/${client}/${year}/${month}`, { headers: headerGroup })

/*Endpoint mesajes de información*/

export const getInfoMessages = (page, headerGroup) => apiGet.get(`/pages/GetPages_messages/${page}`, { headers: headerGroup })

/*Endpoint videos instructivos*/

export const getVideos = (page, headerGroup) => apiUser.get(`/Media/getVideosApp`)

/*Endpoints cargue empleados*/

export const importSalary = (payload, headerGroup) => apib.post(`/upload/PostUpload_salary_hist`, payload, { headers: headerGroup })
export const importEmployees = (payload, headerGroup) => apib.post(`/upload/PostUpload_employee`, payload, { headers: headerGroup })

/*Endpoint saldo inicial*/

export const getInitialBalanceList = (entity, client, headerGroup) => apib.get(`/lov_tables/GetList_Initial_balance/${entity}/${client}`, { headers: headerGroup })
export const postInitialBalance = (payload, headerGroup) => apib.post(`/contract/PostContract_ini_abalance`, payload, { headers: headerGroup })
export const getInitialBalance = (entity, client, contrato, headerGroup) => apib.get(`/contract/GetContract_ini_abalance/${entity}/${client}/${contrato}`, { headers: headerGroup })
export const putInitialBalance = (payload, headerGroup) => apib.put(`/contract/PutContract_ini_abalance`, payload, { headers: headerGroup })
export const deleteInitialBalance = (entity, client, contrato, headerGroup) => apib.delete(`/contract/DelContract_ini_abalance/${entity}/${client}/${contrato}`, { headers: headerGroup })

/*Endpoint validación carta laboral*/

export const getValidateCertificate = (id) => apiUser.get(`/queries/GetValid_information/${id}`)

/*Endpoint plano silog*/

export const plainFileSilog = (payload, headerGroup) => apib.post(`/files_raw/PostReports_Ne_silogtran`, payload, { headers: headerGroup })
/*Endpoint subir imágenes*/

export const postFileS3 = (payload, headerGroup) => apib.post(`/python/postFile`, payload, { headers: headerGroup })

/*Endpoint gráfica seguridad social*/

export const getGraphSS = (entity, client, headerGroup) => apib.get(`/process/GetSso_budget/${entity}/${client}`, { headers: headerGroup })

/*Endpoint tabla conciliacion contable*/

export const getAccountTable = (entity, client, headerGroup) => apib.get(`/process/GetCtb_conciliation/${entity}/${client}`, { headers: headerGroup })

/*Endpoints instancias*/

export const getInstanceLists = (headerGroup) => apib.get(`/instances/GetList_Instances`, { headers: headerGroup })
export const postInstanceAction = (payload, headerGroup) => apib.post(`/instances/PostInstances`, payload, { headers: headerGroup })

/*Endpoint reporte consolidado de prestaciones*/

export const socialBenefitsReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_law_benefits`, payload, { headers: headerGroup })

/*Endpoint reporte horas extra y recargos*/

export const overtimeReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_His_he`, payload, { headers: headerGroup })

/*Captcha endpoint*/

export const postCaptcha = (payload) => apiUser.post(`/Security/postCaptcha`, payload)

/*Endpoint cargue usuarios*/

export const importUsers = (payload, headerGroup) => apib.post(`/upload/PostUpload_users_atg`, payload, { headers: headerGroup })

/*Endpoint cargue novedades*/

export const importOvertime = (payload, headerGroup) => apib.post(`/upload/PostUpload_Nov_time`, payload, { headers: headerGroup })
export const importReported = (payload, headerGroup) => apib.post(`/upload/PostUpload_Nov_reported`, payload, { headers: headerGroup })

/*Endpoints planes*/

export const getPlans = (entity, client, headerGroup) => apib.get(`/Configuration/GetPayment_plans/${entity}/${client}`, { headers: headerGroup })
export const putPlans = (payload, headerGroup) => apib.put(`/Configuration/PutPayment_plans`, payload, { headers: headerGroup })

/*Endpoints procesos adicionales*/

export const getPeriodicAdditionalCalendar = (entity, client, headerGroup) => apib.get(`/process/GetCalendar_periodic_adic/${entity}/${client}`, { headers: headerGroup })
export const getAdditionalCalendar = (entity, client, process, headerGroup) => apib.get(`/process/GetCalendar_adic/${entity}/${client}/${process}`, { headers: headerGroup })
export const postAdditionalCalendar = (payload, headerGroup) => apib.post(`/process/PostCalendar_adic`, payload, { headers: headerGroup })
export const deleteAdditionalCalendar = (entity, client, id, headerGroup) => apib.delete(`/process/DelCalendar_adic/${entity}/${client}/${id}`, { headers: headerGroup })
export const getListNovAdditional = (entity, client, id, headerGroup) => apib.get(`/lov_tables/GetList_Nov_additional/${entity}/${client}/${id}`, { headers: headerGroup })
export const postAdditionalEmployees = (payload, headerGroup) => apib.post(`/process/PostCalendar_adic_employees`, payload, { headers: headerGroup })
export const getAdditionalEmployees = (entity, client, calendar, headerGroup) => apib.get(`/process/GetCalendar_adic_employees/${entity}/${client}/${calendar}`, { headers: headerGroup })
export const deleteAdditionalEmployees = (entity, client, id, headerGroup) => apib.delete(`/process/DelCalendar_adic_employees/${entity}/${client}/${id}`, { headers: headerGroup })
export const postAdditionalReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_nov_additional`, payload, { headers: headerGroup })

/*Endpoint facturación*/

export const getInvoice = (payment, headerGroup) => apib.get(`/invoice/GetDownloadInvoice_docu/${payment}`, { headers: headerGroup })

/**/

export const postPila = (payload, headerGroup) => apib.post(`/files_raw/PostReport_Pila_file`, payload, { headers: headerGroup })
export const getPila = (payload, headerGroup) => apib.post(`/files_raw/PostRecords_Pila_file`, payload, { headers: headerGroup })

/*Endpoint pdf retiros*/

export const getFiredReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_ld`, payload, { headers: headerGroup })
/*Endpoint salarios*/

export const getSalaries = (client, entity, token, headerGroup) => apib.get(`/contract/GetContracts_client_salary/${client}/${entity}/${token}`, { headers: headerGroup })

/*Endpoints cargues varios*/

export const uploadSalaries = (payload, headerGroup) => apib.post(`/upload/PostUpload_Salaries`, payload, { headers: headerGroup })
export const uploadStatics = (payload, headerGroup) => apib.post(`/upload/PostUpload_Nov_Statics`, payload, { headers: headerGroup })
export const uploadParamsAccount = (payload, headerGroup) => apib.post(`/upload/PostUpload_Parameters_account`, payload, { headers: headerGroup })

/*Endpoints bancos*/

export const getBankList = (entity, client, headerGroup) => apib.get(`/lov_tables/GetList_Banks/${entity}/${client}`, { headers: headerGroup })
export const postBank = (payload, headerGroup) => apib.post(`/business/PostBank`, payload, { headers: headerGroup })
export const getBank = (entity, client, headerGroup) => apib.get(`/business/GetBank/${entity}/${client}`, { headers: headerGroup })
export const putBank = (payload, headerGroup) => apib.put(`/business/PutBank`, payload, { headers: headerGroup })
export const deleteBank = (entity, client, id, headerGroup) => apib.delete(`/business/DelBank/${entity}/${client}/${id}`, { headers: headerGroup })

/*Endpoint confirmación carta laboral */

export const postConfirmation = (payload, headerGroup) => apib.post(`/files_raw/PostReports_cert_lab_con`, payload, { headers: headerGroup })

/*Enpoints retefuente*/

export const getRetefuenteReports = (payload, headerGroup) => apib.post(`/files_raw/PostRecords_pdf_retention`, payload, { headers: headerGroup })
export const postRetefuenteReport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_retention`, payload, { headers: headerGroup })

/*Endpoint libro vacaciones*/

export const postVacationCycle = (payload, headerGroup) => apib.post(`/files_raw/PostReports_cycle_vacations`, payload, { headers: headerGroup })

/*Endpoints documentos*/

export const getDocumentList = (entity, client, headerGroup) => apib.get(`/lov_tables/GetList_create_document/${entity}/${client}`, { headers: headerGroup })
export const postDocument = (payload, headerGroup) => apib.post(`/contract/PostDocument_type`, payload, { headers: headerGroup })
export const getDocuments = (entity, client, number_id, headerGroup) => apib.get(`/contract/GetDocument_type/${entity}/${client}/${number_id}`, { headers: headerGroup })
export const delDocument = (entity, client, id, headerGroup) => apib.delete(`/contract/DelDocument_type/${entity}/${client}/${id}`, { headers: headerGroup })
export const getDocumentUrl = (entity, client, id, headerGroup) => apib.get(`/contract/GetUrl_s3_document_type/${entity}/${client}/${id}`, { headers: headerGroup })

/*Endpoints administración documentos*/

export const getDocumentTypeList = (entity, client, headerGroup) => apib.get(`/lov_tables/GetList_extension_files/${entity}/${client}`, { headers: headerGroup })
export const postDocumentType = (payload, headerGroup) => apib.post(`/Configuration/PostType_files`, payload, { headers: headerGroup })
export const getDocumentType = (entity, client, headerGroup) => apib.get(`/Configuration/GetType_file/${entity}/${client}`, { headers: headerGroup })
export const delDocumentType = (entity, client, id, headerGroup) => apib.delete(`/Configuration/DelType_files/${entity}/${client}/${id}`, { headers: headerGroup })
export const putDocumentType = (payload, headerGroup) => apib.put(`/Configuration/PutType_files`, payload, { headers: headerGroup })

/*Endpoint vencimiento contratos*/

export const getWarning = (entity, client, calendar, headerGroup) => apib.get(`/warning/GetWarning_calendar/${entity}/${client}/${calendar}`, { headers: headerGroup })

/*Endpoints notificaciones*/

export const getNotifications = (entity, client, headerGroup) => apib.get(`/warning/GetWarning_notification/${entity}/${client}`, { headers: headerGroup })
export const checkNotification = (payload, headerGroup) => apib.post(`/warning/PostWarning_notification_check`, payload, { headers: headerGroup })

/*Endpoints conf contable*/

export const getAccountingConfList = (headerGroup) => apib.get(`/lov_tables/GetList_config_ctb`, { headers: headerGroup })
export const getAccountingConf = (entity, client, headerGroup) => apib.get(`/Configuration/GetConf_ctb/${entity}/${client}`, { headers: headerGroup })
export const puttAccountingConf = (payload, headerGroup) => apib.put(`/Configuration/PutConf_ctb`, payload, { headers: headerGroup })

/*Endpoint cargue seguridad social*/

export const uploadSocialSecurity = (payload, headerGroup) => apib.post(`/upload/PostUpload_Contract_ini_abalance`, payload, { headers: headerGroup })

/*Reportes retiro*/

export const postReportWorkCertificate = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_cert_ret`, payload, { headers: headerGroup })
export const postReportSeveranceFile = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_ret_fces`, payload, { headers: headerGroup })

/*Reportes liquidación definitiva*/

export const postReportTerminationSupport = (payload, headerGroup) => apib.post(`/files_raw/PostReports_pdf_ld_support`, payload, { headers: headerGroup })

/*Lista de endpoints*/

const apis = {
    postLogin,
    postFirm,
    getFirm,
    putFirm,
    deleteFirm,
    deleteVacation,
    saveUser,
    postIdentity,
    getValueListIdentity,
    putIdentity,
    postContract,
    putContract,
    getValueListContract,
    postBusiness,
    putBusiness,
    getBusiness,
    getValueListCompany,
    getValueListHolidays,
    getValueListCalendar,
    getValueFiles_raw,
    executeProcess,
    getBankFlat,
    getLastCalendar,
    getContracts_client,
    getOvertimeLists,
    getReportedLists,
    getLicensesLists,
    getIdentity,
    getContract,
    postOvertime,
    getOvertime,
    putOvertime,
    deleteOvertime,
    getNoveltiesCalendar,
    getVacation,
    postVacation,
    getVacationLists,
    putVacation,
    postReportVacationHistory,
    postReported,
    getReported,
    putReported,
    deleteReported,
    postLicenses,
    getLicenses,
    putLicenses,
    deleteLicenses,
    getLicenseEndDate,
    getEnd_DateVacation,
    postStatics,
    getStatics,
    putStatics,
    deleteStatics,
    getStaticsLists,
    getSocial_benefitsLists,
    postSocial_benefits,
    getSocial_benefits,
    putSocial_benefits,
    deleteSocial_benefits,
    getValidDateIni,
    postUsers,
    getUsers,
    putUsers,
    deleteUsers,
    getUsersList,
    postJobs,
    getJobs,
    putJobs,
    deleteJobs,
    getCenCosList,
    postCenCos,
    getCenCos,
    putCenCos,
    deleteCenCos,
    getAccountList,
    postAccount,
    getAccount,
    putAccount,
    deleteAccount,
    getValueListFirm,
    getValNit,
    getThirdList,
    getValueListPayrollConf,
    getPayrollConf,
    putPayrollConf,
    getPayrollGroupConf,
    postPayrollGroupConf,
    deletePayrollGroupConf,
    postThird,
    getThird,
    putThird,
    deleteThird,
    postReportPayroll,
    getConceptsPayrollConf,
    getToken,
    saveUserToken,
    getTimeNow,
    postReportCIR,
    postReportSocialSecurity,
    getCIRConfList,
    getCIRConf,
    postCIRConf,
    deleteCIRConf,
    postReportAccounting,
    postReportSeverance,
    postReportSalaryHistory,
    postReportHeadCount,
    PostChange_password,
    getLicenseExtension,
    getExecutedProcess,
    postReportLicenseHistory,
    getValueListReportedConcepts,
    postReportedConcept,
    getReportedConcept,
    putReportedConcept,
    deleteReportedConcept,
    getValueListOpenPayroll,
    postOpenPayroll,
    getValueListHistoricPayroll,
    postHistoricPayroll,
    getValueListHistoricSocialSecurity,
    postHistoricSocialSecurity,
    getValueListHistoricAccounting,
    postHistoricAccounting,
    getAccountListDocumentType,
    postReportAccount,
    postSendEmail,
    postUpdatePassword,
    getUserType,
    postReportElectronicPayroll,
    postSupportMail,
    getTransferDataElectronicPayroll,
    postTransferElectronicPayroll,
    getPayment,
    postPDF,
    postPDFVoucher,
    uploadHistoricPayroll,
    getListDIANProcess,
    postDIANProcess,
    putDIANProcess,
    getDIANProcess,
    putCune,
    putContractSalary,
    validateDIANProcess,
    postVerificationCode,
    getVerificationCode,
    getEpaycoParams,
    getEpaycoTransactions,
    postEpaycoTransaction,
    getCustomerInformation,
    postLegalTerms,
    confReport,
    getGetPayroll_budget,
    getGetEmployee_budget,
    GetPending_invoices,
    getPassiveLabor,
    getTotalPassiveLabor,
    getPayAbsenceType,
    getPayAbsenceDays,
    getVouchers,
    electronicPayrollConf,
    getCIRVouchers,
    postPDFCIRVoucher,
    postReportFlatSeverance,
    getFormat1009,
    getFormat2276,
    getReadDataElectronicPayroll,
    getInfoMessages,
    getPDFFile,
    getVideos,
    acceptTerms,
    importSalary,
    postReportedReport,
    getInitialBalanceList,
    postInitialBalance,
    getInitialBalance,
    putInitialBalance,
    deleteInitialBalance,
    importEmployees,
    getValidateCertificate,
    plainFileSilog,
    postFileS3,
    getGraphSS,
    getAccountTable,
    getInstanceLists,
    postInstanceAction,
    socialBenefitsReport,
    overtimeReport,
    postCaptcha,
    importUsers,
    importOvertime,
    importReported,
    getNoveltiesCalendarSB,
    getPlans,
    putPlans,
    getPeriodicAdditionalCalendar,
    getAdditionalCalendar,
    postAdditionalCalendar,
    deleteAdditionalCalendar,
    getListNovAdditional,
    postAdditionalEmployees,
    getAdditionalEmployees,
    deleteAdditionalEmployees,
    postAdditionalReport,
    getInvoice,
    postPila,
    getPila,
    getFiredReport,
    getSalaries,
    uploadSalaries,
    uploadStatics,
    uploadParamsAccount,
    postConfirmation,
    getBankList,
    postBank,
    getBank,
    putBank,
    deleteBank,
    getRetefuenteReports,
    postRetefuenteReport,
    postVacationCycle,
    getDocumentList,
    getDocuments,
    postDocument,
    delDocument,
    getDocumentUrl,
    getDocumentTypeList,
    getDocumentType,
    postDocumentType,
    putDocumentType,
    delDocumentType,
    getWarning,
    getNotifications,
    checkNotification,
    getAccountingConfList,
    getAccountingConf,
    puttAccountingConf,
    uploadSocialSecurity,
    postReportWorkCertificate,
    postReportSeveranceFile,
    postReportTerminationSupport,
}

export default apis;